<template>
  <v-container>
    <v-layout row align-center class="mb-2">
      <v-btn @click="newCategory"> New Category </v-btn>
      <v-btn
        :disabled="!orderChanged"
        color="primary"
        class="ml-2"
        @click="saveOrder"
      >
        Save Order
      </v-btn>
    </v-layout>
    <draggable
      v-model="localCategories"
      handle=".drag-handle"
      @change="orderChanged = true"
    >
      <v-flex v-for="category in localCategories" :key="category.id">
        <v-card>
          <v-layout row align-center>
            <v-flex shrink>
              <v-icon class="drag-handle mx-2" style="cursor: grab;">
                drag_indicator
              </v-icon>
            </v-flex>
            <v-flex xs-8 grow>
              <v-card-title>
                {{ category.title }}
              </v-card-title>
            </v-flex>
            <v-flex xs-2 shrink>
              <v-btn @click="() => editCategory(category)"> Edit </v-btn>
            </v-flex>
            <v-flex xs-2 shrink>
              <v-btn color="warning" @click="() => deleteCategory(category.id)">
                Delete
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </draggable>
    <v-dialog v-model="dialogOpen" max-width="800px">
      <v-card flat tile height="100%" class="pa-4">
        <v-card-title class="display-1 secondary--text">
          {{ categoryAlreadyExists ? "Edit Category" : "Add a New Category" }}
        </v-card-title>
        <v-form ref="form" @submit.prevent="submitCategory">
          <v-text-field
            v-model="currentCategory.title"
            type="text"
            title="Category Title"
            label="Title"
            :rules="requiredRule"
          />
          <v-textarea
            v-model="currentCategory.description"
            title="Category Description"
            label="Description"
            :rules="requiredRule"
          />
          <div>Upload image</div>
          <input
            id="uploadImage"
            type="file"
            title="Upload Image"
            @change="onFileSelected"
          />
          <v-spacer />
          <v-btn type="submit" :disabled="!validForm" color="primary">
            Submit
          </v-btn>
          <v-btn @click="dialogOpen = false"> Cancel </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "lodash";
import draggable from "vuedraggable";
import { readAsDataURL } from "promise-file-reader";

export default {
  components: {
    draggable
  },
  data() {
    return {
      dialogOpen: false,
      categoryAlreadyExists: false,
      currentCategory: {},
      requiredRule: [v => !!v || "Required"],
      valid: true,
      localCategories: [],
      orderChanged: false
    };
  },
  computed: {
    validForm() {
      if (!this.dialogOpen) {
        return false;
      }
      if (this.categoryAlreadyExists) {
        let originalCategory = _.find(this.localCategories, category =>
          _.isEqual(category.id, this.currentCategory.id)
        );
        return !_.isEqual(originalCategory, this.currentCategory);
      }
      // title, description, shield(s) and tags are required
      let { description, title } = this.currentCategory;
      console.log(this.currentCategory);
      if (!title || !description) {
        return false;
      }
      return true;
    }
  },
  watch: {
    "$store.state.categories"(categories) {
      // Sync local copy when store updates, but only if the admin hasn't
      // made unsaved drag changes (to avoid resetting mid-reorder)
      if (!this.orderChanged) {
        this.localCategories = _.cloneDeep(categories);
      }
    }
  },
  mounted() {
    this.$store.dispatch("fetchCategories");
    this.localCategories = _.cloneDeep(this.$store.state.categories);
  },
  methods: {
    saveOrder() {
      const orderedIds = this.localCategories.map(c => c.id);
      this.$store.dispatch("saveCategoryOrder", orderedIds);
      this.orderChanged = false;
    },
    newCategory() {
      this.categoryAlreadyExists = false;
      this.currentCategory = {};
      document.getElementById("uploadImage").value = "";
      this.dialogOpen = true;
    },
    editCategory(category) {
      this.categoryAlreadyExists = true;
      this.currentCategory = _.cloneDeep(category);
      document.getElementById("uploadImage").value = "";
      this.dialogOpen = true;
    },
    deleteCategory(id) {
      const index = this.localCategories.findIndex(c => c.id === id);
      if (confirm("Are you sure you want to delete this category?")) {
        this.$store.dispatch("deleteCategory", this.localCategories[index]);
      }
    },
    onFileSelected(event) {
      readAsDataURL(event.target.files[0]).then(result => {
        this.currentCategory.imgsrc = result;
      });
    },
    submitCategory() {
      if (this.categoryAlreadyExists) {
        this.$store.dispatch("updateCategory", this.currentCategory);
      } else {
        this.$store.dispatch("addCategory", this.currentCategory);
      }
      this.dialogOpen = false;
    }
  }
};
</script>
